export { default } from './DialogActions';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/DialogActions/index.js
// module id = 165
// module chunks = 0